import usePagination from '@/hooks/usePagination';
import { useStaffRolesWithRoleProfileQuery } from '@/modules/corporate/modules/staff-roles/graphql/queries/generated/staffRolesWithRoleProfile';
import { RolesFilters, SortType } from '@/types/schema';

export default function useStaffRolesWithRoleProfile({
  filters,
  sort,
  pause,
}: {
  filters?: RolesFilters;
  sort?: SortType | SortType[];
  pause?: boolean;
}) {
  const {
    data,
    error,
    isFetchingMore,
    fetchMore,
    isFetching,
    totalCount = 0,
  } = usePagination(
    useStaffRolesWithRoleProfileQuery,
    {
      filters,
      sort,
    },
    { edgeKey: 'staffRoles', pause },
  );

  return {
    staffRoles: data,
    totalCount,
    isFetchingMore,
    initialFetching: isFetching,
    error,
    fetchMore,
  };
}
